/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc ボタンリストメッセージ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */
<script>
import FcQuestionMessage from './FcQuestionMessage'
import FcMessageUtil from '@/utils/FcMessageUtil'
import WindowUtil from '@/utils/WindowUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'

export default {
  mixins: [FcQuestionMessage],
  name: 'FcButtonListMessage',
  computed: {
    /**
     * messageClass のオーバーライド
     */
    messageClass() {
      return 'fc-button-list-message ' + 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * answerList のオーバーライド
     */
    answerList() {
      let messageOption = JSON.parse(this.messageInfo.messageOption)
      let answerList = messageOption.buttons.map((buttonInfo, index) => {
        return {
          id: index,
          label: buttonInfo.label,
          type: buttonInfo.type,
          data: buttonInfo.data,
          url: buttonInfo.url,
          alwaysEnable: buttonInfo.type === MessageInfoConst.MESSAGE_OPTION_BUTTON_TYPE_URL
        }
      })
      return answerList
    }
  },
  methods: {

    /**
     * sendAnswerMessage のオーバーライド
     */
    sendAnswerMessage(answerInfo) {
      if (!this.permissionSendAnswerMessage(answerInfo)) {
        return
      }
      const buttonType = answerInfo.type
      if (MessageInfoConst.MESSAGE_OPTION_BUTTON_TYPE_TEXT === buttonType || MessageInfoConst.MESSAGE_OPTION_BUTTON_TYPE_POSTBACK === buttonType) {
        this.$emit('sendAnswerMessage', this.getSendAnswerMessageByAnswerInfo(answerInfo))
      } else if (MessageInfoConst.MESSAGE_OPTION_BUTTON_TYPE_URL === buttonType) {
        WindowUtil.openWindow(answerInfo.url)
      }
    },
    /**
     * getSendMessageAnswerList のオーバーライド
     */
    getSendMessageAnswerList() {
      return this.answerList.filter((answer) => {
        return MessageInfoConst.MESSAGE_OPTION_BUTTON_TYPE_URL !== answer.type
      })
    },
    /**
     * getSendAnswerMessageByAnswerInfo のオーバーライド
     */
    getSendAnswerMessageByAnswerInfo(answerInfo) {
      return {
        messageText: answerInfo.label,
        postbackData: answerInfo.data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcButtonListMessage.vue